import React from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import { navigate } from "vike/client/router"

const PriceDialog = ({ isOpen, onClose, onContinue }) => {
  const handleSelectPrice = () => {
    navigate("/pricing")
  }

  const texts = TextBundle({ id: "cancellation_price_dialog" })

  return (
    <Modal
      title={texts?.title}
      isOpen={isOpen}
      onClose={onClose}
      variant="aqua_medium"
      className="md:max-w-[500px]"
    >
      <div className="max-w-[360px] md:max-w-full space-y-14 pt-10 md:pt-6 mx-auto md:mx-0">
        <Typography 
          variant="info_18"
          className="text-gray_1 text-center md:text-left my-0"
        >
          {texts?.subtitle}
        </Typography>

        <div className="space-y-4">
          <Button
            variant="secondary_s"
            onClick={handleSelectPrice}
            className="w-full"
          >
            {texts?.cta_better_price}
          </Button>
          <Button 
            variant="secondary_s" 
            onClick={onContinue} 
            className="w-full"
          >
            {texts?.cta_continue}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default PriceDialog
